import { Group, Paper, Text, ThemeIcon } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export function CognitiveDisclaimerBanner() {
  const { t } = useTranslation();
  return (
    <Paper
      p="md"
      radius="md"
      mb="md"
      withBorder
      style={{
        backgroundColor: "var(--oculera-tint-blue)",
        borderColor: "var(--oculera-tint-blue-border)",
      }}
    >
      <Group gap="sm" wrap="nowrap" align="flex-start">
        <ThemeIcon size={28} radius="xl" variant="light" color="blue">
          <IconInfoCircle size={18} />
        </ThemeIcon>
        <Text size="sm" c="blue.9">
          {t("cognitiveProfile.disclaimer")}
        </Text>
      </Group>
    </Paper>
  );
}
